const colors = [
  "rgba(54, 162, 235, 1)",
  "rgba(255, 99, 132, 1)",
  "rgba(255, 206, 86, 1)",
  "rgba(75, 192, 192, 1)",
  "rgba(153, 102, 255, 1)",
  "rgba(255, 159, 64, 1)",
];

const borderColor = [
  "rgba(54, 162, 235, 0.2)",
  "rgba(255, 99, 132, 0.2)",
  "rgba(255, 206, 86, 0.2)",
  "rgba(75, 192, 192, 0.2)",
  "rgba(153, 102, 255, 0.2)",
  "rgba(255, 159, 64, 0.2)",
];

export const generateColor = (
  num: number = 1,
  type?: "background" | "border"
): string[] => {
  switch (type) {
    case "background":
      return colors.slice(0, num);
    case "border":
      return borderColor.slice(0, num);
    default:
      return colors.slice(0, num);
  }
};

export const randomColor = () => {
  return colors[Math.floor(Math.random() * colors.length)];
};
